module.exports = __webpack_public_path__ + "img/card-plus.45e1c08a.svg";